import Card from '@/components/ui/Card';
import WinnerBadge from '@/components/sponsors/WinnerBadge';
import { sponsorsEnabled } from '@/lib/feature-flags';
import { Navigate, Link } from 'react-router-dom';

const recentWinners = [
  {
    classroom: 'Ms. Rivera • Oak Ridge Elementary',
    location: 'Columbus, OH',
    nominationCount: 18,
    drawLabel: 'Winter Pilot Draw #4',
    highlight: 'STEM makerspace rebuild',
  },
  {
    classroom: 'Mr. Chen • Northview Middle',
    location: 'Tacoma, WA',
    nominationCount: 12,
    drawLabel: 'Winter Pilot Draw #4',
    highlight: 'Robotics league season kickoff',
  },
  {
    classroom: 'Ms. Patel • Hillside Elementary',
    location: 'Birmingham, AL',
    nominationCount: 21,
    drawLabel: 'Winter Pilot Draw #3',
    highlight: 'Reading nook & culturally responsive library',
  },
  {
    classroom: 'Mr. Gomez • Southside High',
    location: 'San Antonio, TX',
    nominationCount: 9,
    drawLabel: 'Fall Pilot Draw #2',
    highlight: 'Career pathways field trips',
  },
  {
    classroom: 'Ms. Thompson • Bridgeview K-8',
    location: 'Milwaukee, WI',
    nominationCount: 15,
    drawLabel: 'Fall Pilot Draw #2',
    highlight: 'Sensory-friendly classroom setup',
  },
  {
    classroom: 'Mr. Hughes • Eastside Elementary',
    location: 'Atlanta, GA',
    nominationCount: 11,
    drawLabel: 'Fall Pilot Draw #1',
    highlight: 'Math lab tablets & coaching',
  },
];

export default function SponsorRecent() {
  if (!sponsorsEnabled()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="space-y-10">
      <header className="space-y-3 text-center">
        <span className="text-xs uppercase tracking-wide text-cocoa/60">Sponsor Program</span>
        <h1 className="text-3xl font-semibold text-cocoa">Recent Sponsor Draw Highlights</h1>
        <p className="mx-auto max-w-2xl text-sm text-cocoa/70">
          Each Sponsor Slot is matched through a weighted draw. These classrooms were nominated by their communities,
          confirmed by their teachers, and selected during recent $800 draws.
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {recentWinners.map((winner) => (
          <Card key={winner.classroom} className="flex h-full flex-col justify-between bg-white/85 p-5">
            <div className="space-y-3">
              <div>
                <p className="text-sm uppercase tracking-wide text-cocoa/60">{winner.drawLabel}</p>
                <h2 className="text-lg font-semibold text-cocoa">{winner.classroom}</h2>
                <p className="text-sm text-cocoa/60">{winner.location}</p>
              </div>
              <p className="text-sm text-cocoa/75">Impact: {winner.highlight}</p>
            </div>
            <div className="mt-4">
              <WinnerBadge nominationCount={winner.nominationCount} />
            </div>
          </Card>
        ))}
      </div>

      <Card className="space-y-3 bg-shell/70 p-6 text-sm text-cocoa/75">
        <h2 className="text-lg font-semibold text-cocoa">Want your classroom considered?</h2>
        <p>
          Teachers confirm readiness in the Project Tower portal, then share their code so families and community members can
          submit nominations. Once confirmed, every nomination increases their odds in the next draw.
        </p>
        <div className="flex flex-wrap gap-3">
          <Link className="btn" to="/nominate">
            Nominate
          </Link>
          <Link className="btn bg-white text-cocoa border border-sand hover:bg-shell" to="/sponsor">
            Become a sponsor
          </Link>
        </div>
      </Card>
    </div>
  );
}
